import React from 'react'
import styled from 'styled-components'
import { UncontrolledAlert } from 'reactstrap'
import get from 'lodash/get'
import some from 'lodash/some'
import find from 'lodash/find'
import GraphIcon from '../../../../static/images/graph-icon.svg'
import { EfficiencySummary /* , DoughnutChart */ } from '../../components'
import { FONTS } from '../../../../constants'

export default class Overall extends React.Component {
  render() {
    let isEmpty = false
    let isMissing = false
    let unsubmitted = []
    const selectedIDs = get(this.props, 'selectedIDs', [])
    const setDefault = get(this.props, 'setDefault')
    const period = get(this.props, 'period')
    const lobs = get(this.props, 'lobs', [])
    const lob_ids = get(this.props, 'lob_ids', '')
    const overallSummary = get(this.props, 'overallSummary', [])
    // const chargeableSummary = get(this.props, 'chargeableSummary', [])
    const efficiencyResources = get(this.props, 'efficiencyResources', []).filter(res => {
      if (lob_ids !== '') {
        return get(res, 'is_submited') && lob_ids.includes(get(res, 'lob_id'))
      } else if (lob_ids === '' && !setDefault) {
        return null
      }
      return get(res, 'is_submited')
    })
    if (efficiencyResources && !some(efficiencyResources, ['is_submited', true])) {
      isEmpty = true
    } else if (efficiencyResources.length !== selectedIDs.length && selectedIDs.length > 0) {
      isMissing = true
      unsubmitted = selectedIDs.filter(id => {
        const resResult = efficiencyResources.filter(res => {
          return get(res, 'lob_id') === get(id, 'value')
        })
        const lobResult = find(lobs, {
          _id: get(id, 'value'),
        })
        return lobResult && resResult.length === 0
      })
    }
    if (isEmpty) {
      return (
        <Col>
          <Icon src={ GraphIcon } />
          <br />
          <span style={ { fontFamily: FONTS.GOTHAM_MEDIUM, fontSize: FONTS.TITLE_SIZE } }>
            No Data
          </span>
          <span style={ { fontFamily: FONTS.GOTHAM, fontSize: FONTS.SMALL_SIZE } }>
            { `Efficiency Resource of ${period.format('MMMM YYYY')} has not been submitted yet.`}
          </span>
        </Col>
      )
    }
    return (
      <Wrapper>
        { isMissing &&
          <UncontrolledAlert color="warning" style={ { width: '100%', height: 'fit-content' } }>
            { `Unsubmitted efficiency resource from LOB: ` }
            { unsubmitted.map((s, key) => {
              if (key === unsubmitted.length - 1) return `${get(s, 'label')}`
              return `${get(s, 'label')}, `
            }) }.
          </UncontrolledAlert>
        }
        <ChildWrapper width={ 100 }>
          <EfficiencySummary
            idChart={ 'overallSummary' }
            header={ 'Overall Summary' }
            efficiencySummary={ overallSummary }
            widthLeft={ 280 }
          />
        </ChildWrapper>
        {/* <ChildWrapper>
          <DoughnutChart
            header={ 'Chargeable Summary' }
            label={ ['Chargeable', 'Non-Chargeable'] }
            remark={ '*Chargeable is On-Project and Forecast Project.' }
            summary={ [
              parseFloat(get(chargeableSummary, 'chargeablePercent')).toFixed(2),
              parseFloat(get(chargeableSummary, 'nonChargeablePercent')).toFixed(2),
            ] }
          />
        </ChildWrapper> */}
        { efficiencyResources.map(res => {
          const lob = find(lobs, { _id: get(res, 'lob_id') })
          return (
            <ChildWrapper width={ 50 } key={ get(res, 'lob_id') }>
              <EfficiencySummary
                idChart={ `summay${get(res, 'lob_id')}` }
                header={ get(lob, 'name', '') }
                efficiencySummary={ get(res, 'efficiency_resource_snapshot.efficiencySummary') }
                widthLeft={ 50 }
              />
            </ChildWrapper>
          )
        }) }
      </Wrapper>
    )
  }
}

const Wrapper = styled.div`
  font-family: Gotham;
  font-size: 14px ;
  height: calc(100vh - 150px);
  overflow-y: scroll;
  overflow-x: hidden;
  width: 100%;
  display: flex;
  flex-wrap: wrap;
`
const ChildWrapper = styled.div`
  width: ${props => props.width}%;
  /* :nth-child(2) {
    width: 50%;
  } */
  @media (max-width: 1500px) {
    width: 100%;
  }
`
const Col = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  margin-top: 10%;
`
const Icon = styled.img`
  height: 20%;
  width: 20%;
`



// WEBPACK FOOTER //
// ./src/components/efficiency-resource/tab-content/overall/index.js